// extracted by mini-css-extract-plugin
export default {"list":"MessageList_list__GsZWW","dayDivider":"MessageList_dayDivider__EwGJ9","dayDividerLabel":"MessageList_dayDividerLabel__s7bJx"};